import { observer } from 'mobx-react-lite';
import { bibleState } from '@/state/bible-state';
import { publicPath } from '@utils/public-path';

interface IconProps {
  className?: string;
  tint?: 'header' | 'none';
}

export const PrayIcon = observer(function PrayIcon({ className, tint = 'none' }: IconProps) {
  const src = bibleState.isDarkMode ? publicPath('icons/pray-dark.png') : publicPath('icons/pray-light.png');
  const heightMatch = className?.match(/h-(\d+)/);
  const height = heightMatch ? `${parseInt(heightMatch[1]) * 4}px` : '20px';

  const filter =
    tint === 'header'
      ? bibleState.isDarkMode
        ? 'sepia(50%) saturate(150%) brightness(80%) hue-rotate(140deg)'
        : 'sepia(50%) saturate(100%) brightness(60%) hue-rotate(140deg)'
      : undefined;

  // Explicit square box + maxWidth:none: Tailwind preflight's
  // `img { max-width: 100% }` is circular inside a shrink-to-fit flex
  // button (content box 0 → 100% of 0 → 0px icon), so the icon must
  // opt out and size itself like the sibling SVGs do.
  return (
    <img
      src={src}
      alt="Prayer"
      style={{ height, width: height, maxWidth: 'none', objectFit: 'contain', filter }}
    />
  );
});
